module.exports = __webpack_public_path__ + "static/media/CURVE-3Pool.494d523d.png";